import React from 'react';


function Footer(){
    return(
        <footer className="footer">
          <p>
            <b>Copyright 2023 All Right Reserved </b>
            <br />
            <b className="space"> ❤ Create By Varun Walia</b>
          </p>
        </footer>
    )
}
export default Footer;